import React from 'react';
import * as Styled from '../../styling/styled';
const PriceLevels = ({ level, intersect }) => (React.createElement(Styled.LadderPrice, { "$intersect": intersect },
    React.createElement("span", { className: "price_ladder_header_text" }, level)));
export default PriceLevels;
